module.exports = __webpack_public_path__ + "assets/icons/baseline-add_location-24px-83a0.svg";